<template>
  <div class="printing-header-root">
    <h3 class="printing-header-title">
      {{ local.print.title }}
    </h3>

    <div class="printing-header-logo">
      <img
        src="@/assets/images/moj-old-logo.png"
        alt="MOJ Logo"
      >
    </div>

    <div class="wings">
      <div class="wing">
        <h3>{{ local.appointmentTicket.country }}</h3>
        <h3>{{ local.appointmentTicket.ministry }}</h3>
      </div>
      <div class="wing">
        <slot />
      </div>
    </div>

    <div class="page-title">
      <h1>{{ title }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.printing-header-root {
  .printing-header-title {
    text-align: center;
  }

  .printing-header-logo {
    text-align: center;
    margin-bottom: -50px;
    margin-top: 10px;
  }

  .wings {
    flex: 1;
    display: flex;
    justify-content: space-between;
    text-align: center;
  }

  .page-title {
    text-align: center;
    padding-top: 15px;
    padding-bottom: 10px;
  }
}
</style>
